
import { Prop, Vue, Component } from 'vue-property-decorator'
import { GalleryImage } from '@/interfaces/GalleryImage'

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

@Component({
  components: {
    CoolLightBox
  }
})
export default class Gallery extends Vue {
  @Prop() private images!: GalleryImage[];
  private index: number | null = null;

  openGallery (index: number) {
    this.index = index
  }

  get galleryImages () {
    return this.images.map((image: GalleryImage) => {
      return image.url
    })
  }
}
